
/* User defined models */
import { DynamicFormBase } from './dynamic-form-base.model';

export class ProSchedulerCheckbox extends DynamicFormBase<string> {

    controlType = 'checkbox';
    type: string;

    constructor(options: {} = {}) {
        super(options);
        this.type = options['type'] || '';
    }
}